// covered-by: frontends/carrie/src/ask-v2/services/__tests__/reviews.test.ts
import {
  createAskPunttReviewCommentResponseSchema,
  getAskPunttReviewResponseSchema,
  type AskPunttReviewCommentWriteBody,
  type CreateAskPunttReviewCommentResponse,
  type GetAskPunttReviewResponse,
} from "@mg/schemas/src/christo/askPunttReview";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

const reviewsBase = `${API_URL}/private/catalyst/ask-puntt/reviews`;

export async function getAskPunttReview(
  reviewId: string,
): Promise<GetAskPunttReviewResponse> {
  const json = await smartFetch(`${reviewsBase}/${reviewId}`);
  return getAskPunttReviewResponseSchema.parse(json);
}

/**
 * Adds a human comment to a V2 review. christo stamps `createdBy` from the
 * caller's token and stores the pin location (`rel_x`/`rel_y`/`page_num`) on
 * the review document.
 */
export async function createAskPunttReviewComment(
  reviewId: string,
  body: AskPunttReviewCommentWriteBody,
): Promise<CreateAskPunttReviewCommentResponse> {
  const json = await smartFetch(`${reviewsBase}/${reviewId}/comments`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  return createAskPunttReviewCommentResponseSchema.parse(json);
}
